export default class Grain {

constructor($element) {
  this.view = {
    width: null,
    height: null
  }

  this.canvas = document.createElement('canvas')
  this.canvas.width = parseInt(window.getComputedStyle($element).width)
  this.canvas.height = parseInt(window.getComputedStyle($element).height)
  this.canvas.style.position = 'absolute'
  this.canvas.style.top = '0'
  this.canvas.style.left = '0'
  $element.appendChild(this.canvas)
  this.ctx = null

  this.pattern = {
    size: 200,
    scaleX: 1,
    scaleY: 1,
    refreshInterval: 5,
    alpha: 15,
    canvas: null,
    ctx: null,
    data: null
  }
  this.pattern.pixelDataLength = this.pattern.size * this.pattern.size * 4

  this.frame = 0

  this.initCanvas()
  this.initGrain()
  requestAnimationFrame(() => { this.loop })
  }

  initCanvas() {
    this.view.width = this.canvas.width = this.canvas.clientWidth
    this.view.height = this.canvas.height = this.canvas.clientHeight
    this.ctx = this.canvas.getContext('2d')

    this.ctx.scale(this.pattern.scaleX, this.pattern.scaleY)
  }

  initGrain() {
    this.pattern.canvas = document.createElement('canvas')
    this.pattern.canvas.width = this.pattern.size
    this.pattern.canvas.height = this.pattern.size
    this.pattern.ctx = this.pattern.canvas.getContext('2d')
    this.pattern.data = this.pattern.ctx.createImageData(this.pattern.size, this.pattern.size)
  }

  update() {
    this.value = null

    for (var i = 0; i < this.pattern.pixelDataLength; i += 4) {
        this.value = (Math.random() * 255) | 0

        this.pattern.data.data[i] = this.value
        this.pattern.data.data[i + 1] = this.value
        this.pattern.data.data[i + 2] = this.value
        this.pattern.data.data[i + 3] = this.pattern.alpha
    }

    this.pattern.ctx.putImageData(this.pattern.data, 0, 0)
  }

  draw() {
    this.ctx.clearRect(0, 0, this.view.width, this.view.height)

    this.ctx.fillStyle = this.ctx.createPattern(this.pattern.canvas, 'repeat')
    this.ctx.fillRect(0, 0, this.view.width, this.view.height)
  }

  loop() {
    if (++this.frame % this.pattern.refreshInterval === 0) {
        this.update()
        this.draw()
    }

    requestAnimationFrame(() => { this.loop })
  }
}